module.exports = __webpack_public_path__ + "img/sodeystvie.531eb5b.jpg";